import React, {useState} from "react";
import t from "../translate";
import apiCall from "../api";

const ForgotPassword = (props) => {

  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);

  const [showForm, setShowForm] = useState(true);



  const onSubmit = e => {
    e.preventDefault();
    setError(false)

    apiCall({
      action: "request_new_password",
      data: {
        email: email,
      }
    }).then(resp => {
      if (resp.send === true) {
        setShowForm(false);
      } else {
        setError(t("De opgegeven gebruikersnaam / e-mailadres is niet gekoppeld aan een account."));
      }
    });
  };

  return (
    <>
    {
    showForm ?
      <form
        className={"forgot"  + (!props.showForgot ? ' hide':'')}
        onSubmit={e => {
          onSubmit(e);
        }}
        >
        <div
          className={error == false ? "hidden" : "alert alert-danger"}
          role="alert"
        >
          <i className="fas fa-exclamation-circle"></i>{" "}
          {t(error)}
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            name="email"
            aria-describedby="email"
            placeholder={t("Gebruikersnaam of e-mailadres")}
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoCorrect="off" 
            autoCapitalize="none"
          />
        </div>
          <button type="submit" className="btn btn-primary" style={{marginTop: '20px'}}>
            {t("Vraag aan")}
          </button>
        <br /><br /><br />
        <span className="forgotPassword" onClick={()=>props.toggleForgotPassword()}>{t('Terug')}</span>
        
      </form>
      :
      <div>
        <h3>{t("Wachtwoord vergeten")}</h3>
        <p>
          {t("Je ontvangt binnen enkele minuten een e-mail van ons waarmee je je wachtwoord opnieuw in kunt stellen.")}
          <br /><br /><br />
        </p>
      </div>
      }
      
      </>
  )
}

export default ForgotPassword
